import {isArray} from 'lodash';
import {i18n} from '@/i18n';
import {consumeMessages} from '@/store/api';
import {err, success} from './toast';

export function setCookie(name: string, value: string, days: number, path: string) {
    let expires = '';

    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${value || ''}${expires}; path=${path}`;
}

export function getCookie(name: string) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');

    for (let c of ca) {
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
}

export function deleteCookie(name: string) {
    document.cookie = `${name}=; Max-Age=-99999999;`;
}

export function decodeCookie(message: string | null): any[] {
    if (message) {
        const decodedMessage = decodeURIComponent(message);

        if (decodedMessage) {
            try {
                return JSON.parse(decodedMessage);
            } catch (e) {
                return [];
            }
        }
    }

    return [];
}

export function encodeCookie(message: any[]): string {
    if (message) {
        return encodeURIComponent(JSON.stringify(message));
    }

    return '';
}

export function displayCookieMessages() {
    const messages = decodeCookie(getCookie('mage-messages'));

    if (isArray(messages)) {
        messages.forEach((message) => {
            if (message.type === 'error') {
                err(i18n.t(message.text).toString());
            }
        });
    }

    setCookie('mage-messages', '', 0, '/');
}

export async function consumeAllMessages() {
    const messages = await consumeMessages();

    if (isArray(messages)) {
        messages.forEach((message) => {
            if (message.text !== '') {
                if (message.type === 'error') {
                    err(message.text);
                } else if (message.type === 'success') {
                    success(message.text);
                }
            }
        });
    }
}
